// extracted by mini-css-extract-plugin
module.exports = {"container":"_3NgsUBT18Kv5D2CB3u_ts4"};